import { MagnetoStatusUpdatedNotificationDifferences } from './magneto-status-updated-notification-differences.model';

export class MagnetoStatusUpdatedNotification {
    constructor(json: any = null) {
        if (json) {
            Object.assign(this, json);

            if (json.Date) {
                this.Date = new Date(json.Date);
            }

            if (json.Differences) {
                this.Differences = [];
                json.Differences.forEach(difference => {
                    this.Differences.push(new MagnetoStatusUpdatedNotificationDifferences(difference));
                });
            }
        }
    }

    public APAN: number;
    public BootVersion: number;
    public Comment: string;
    public ConfigType: string;
    public Date: Date;
    public DawnOffset: number;
    public DeviceUId: string; MagnetoStatusUpdatedNotificationDifferences
    public Differences: MagnetoStatusUpdatedNotificationDifferences[];
    public DuskOffset: number;
    public FirmwareVersion: number;
    public HardwareVersion: number;
    public IdOfActualConfig: number;
    public IdOfExpectedConfig: number;
    public IsAutoOn: boolean;
    public IsOn: boolean;
    public LPCUId: number;
    public Latitude: number;
    public Longitude: number;
    public MinutesSinceLastUpdate: number;
    public Pin: number;
    public ResourceType: string;

    public ScheduleAOffTimeHour: number;
    public ScheduleAOffTimeHour2: number;
    public ScheduleAOffTimeMinute: number;
    public ScheduleAOffTimeMinute2: number;
    public ScheduleAOffTimeOption: number;
    public ScheduleAOffTimeOption2: number;
    public ScheduleAOnTimeHour: number;
    public ScheduleAOnTimeHour2: number;
    public ScheduleAOnTimeMinute: number;
    public ScheduleAOnTimeMinute2: number;
    public ScheduleAOnTimeOption: number;
    public ScheduleAOnTimeOption2: number;

    public ScheduleBOffTimeHour: number;
    public ScheduleBOffTimeHour2: number;
    public ScheduleBOffTimeMinute: number;
    public ScheduleBOffTimeMinute2: number;
    public ScheduleBOffTimeOption: number;
    public ScheduleBOffTimeOption2: number;
    public ScheduleBOnTimeHour: number;
    public ScheduleBOnTimeHour2: number;
    public ScheduleBOnTimeMinute: number;
    public ScheduleBOnTimeMinute2: number;
    public ScheduleBOnTimeOption: number;
    public ScheduleBOnTimeOption2: number;

    public ShortId: number;
    public Temperature: number;
    public TypeCode: number;
    public UseDaylightSavings: boolean;
    public UtcOffset: number;
    public Version: number;
    public WKD_A: number;
    public WKD_B: number;
}
